//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "EmptyMessage",
  props: {
    text: {
      type: null,
      default: ""
    }
  },
  computed: {
    computedText() {
      return this.text || this.$t("notifications.messages.noNotifications");
    }
  }
});